<template>
  <div class="home-content">
    <div class="mine-header">
      <span @click="util.goblack()" class="back"><img src="@/assets/images/base/icon_righ_g.png" /></span>Digital Wallet
      <span class="add-wallet" @click="addWallet()"><img src="@/assets/images/base/add_icon.png" /></span>
    </div>
    <div class="third-pard">
      <div v-show="!nodata">
        <div class="list" v-for="(i, index) in list" v-bind:key="index">
          <ul>
            <li class="des">
              <div>Currency</div>
              <div>{{ i.type_1 }}/{{ i.type_2 }}</div>
              <div></div>
            </li>
            <li class="des">
              <div>Address</div>
              <div v-clipboard:error="util.onError" v-clipboard:copy="i.wallet_url" v-clipboard:success="util.onCopy">{{ i.wallet_url }}
              </div>
              <div><button style="color:brown;">Copy</button></div>
            </li>
            <li class="des">
              <div>Comment</div>
              <div>{{ i.remark }}</div>
              <div></div>
            </li>
            <div class="edit-wallet">
              <button class="btn" @click="updateWallet(i)">Modify</button>
              <button class="btn" @click="delWallet(i.id)">Delete</button>
            </div>
          </ul>
        </div>
      </div>
      <div class="nodata" v-show="nodata"><img src="@/assets/images/icon/data_icon_219962.png" /><span>No data available</span></div>
      <div class="show-more" v-if="list.length >= 10" @click="showMore()">{{ hasMore ? "See more records, click here" : "No more data" }}</div>
    </div>
    <div class="edit-pard" v-if="isEdit">
      <div class="edit-head">
        <div @click="isEdit = false"><img src="@/assets/images/base/icon_righ_g.png" /></div>
        <div v-if="Object.keys(one).length === 0">Add Digital Wallet</div>
        <div v-else>Modify Digital Wallet</div>
        <div></div>
      </div>
      <div class="edit-content">
        <ul>
          <li>
            <div class="icon-input">Currency</div>
            <input type="text" readonly v-model="one.type_1" placeholder="Please select currency" @click="showtype_1=true" />
            <van-picker class="van_picker" toolbar-position="top" v-show="showtype_1" :columns="currency" show-toolbar title="Select digital currency" @cancel="onCancel" @confirm="onConfirm1" confirm-button-text="OK" cancel-button-text="Cancel"/>
          </li>
          <li>
            <div class="icon-input">Classification</div>
            <input type="text" readonly v-model="one.type_2" placeholder="Please select classification" @click="changeType2()"/>
            <van-picker class="van_picker" v-show="showtype_2" :columns="type2" show-toolbar title="Select classification" @cancel="onCancel" @confirm="onConfirm2" confirm-button-text="OK" cancel-button-text="Cancel"/>
          </li>
          <li>
            <div class="icon-input">Address</div>
            <textarea v-model="one.wallet_url" placeholder="Please enter wallet address" />
          </li>
          <li>
            <div class="icon-input">Comment</div>
            <textarea v-model="one.remark" placeholder="Please enter comment"/>
          </li>
          <li>
            <button class="btn-submit" v-show="!showloding" @click="submitbtn">Save</button>
            <button class="btn-submit" v-show="showloding">Save</button>
          </li>
        </ul>
      </div>
    </div>
    <van-loading v-show="showloding" size="50px" color="#1989fa" vertical />
  </div>
</template>
<script>
/*global mui*/
import Vue from "vue";
import { Loading } from "vant";
import { Picker } from 'vant';
Vue.use(Picker);
Vue.use(Loading);
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
export default {
  data() {
    return {
      showloding: false,
      timeType: 1,
      nodata: true,
      status: 1,
      pageNo: 1,
      pageSize: 10,
      hasMore: true,
      list: [],
      one: {},
      isEdit: false,
      currency:['USDT','BTC','ETH','DOGE','SOC','CHZ','BCH','PSG','JUV','ATM','LTC','KSM','EOS','LINK','HT','UNI','TRX','XRP','XAUT','FIL','ADA'],
      type2:['TRC20','ERC20'],
      showtype_1:false,
      showtype_2:false,
    };
  },
  methods: {
    onCancel(){
      this.showtype_1 = false;
      this.showtype_2 = false;
    },
    onConfirm1(value){
      this.one.type_1 = value;
      this.one.type_2 = value;
      if(value=='USDT') {
        this.one.type_2 = 'TRC20';
        //this.showtype_2 = true;
      }
      this.showtype_1 = false;
    },
    changeType2(){
      if(this.one.type_1=='USDT') {
        this.showtype_2=true;
      }
    },
    onConfirm2(value){
      this.one.type_2 = value;
      if(value=='USDT') this.showtype_2 = true;
      this.showtype_2 = false;
    },
    addWallet() {
      this.isEdit = true;
      this.one = {};
    },
    updateWallet(item) {
      this.isEdit = true;
      this.one = item;
    },
    submitbtn(){
      if (!this.one.type_1) {
        mui.alert("Digital currency cannot be empty");
      }else if(!this.one.type_2){
        mui.alert("Currency category cannot be empty");
      }else if(!this.one.wallet_url){
        mui.alert("Wallet address cannot be empty");
      }else if (!this.showloding) {
        if (this.one.id > 0) this.updateWalletSave();
        else this.addWalletSave();
      }
    },
    addWalletSave() {
      let params = {
        type_1:this.one.type_1,
        type_2:this.one.type_2,
        wallet_url:this.one.wallet_url,
        remark:this.one.remark
      };
      this.util.setDnValueUser(params);
      this.axios.post(this.api.api_addDigitalWallet, this.util.encodeSearchParams(params)).then(res => {
          this.showloding = false;
          if (res.data.code == 0) {
            mui.toast("Add succeeded");
            this.isEdit=false;
            this.list = [];
            this.getWallet();
          } else {
            mui.toast(res.data.message);
          }
        })
        .catch(() => {
          this.showloding = false;
          mui.toast("Add failed");
        });
    },
    updateWalletSave() {
      let params = {
        walletId:this.one.id,
        type_1:this.one.type_1,
        type_2:this.one.type_2,
        wallet_url:this.one.wallet_url,
        remark:this.one.remark
      };
      this.util.setDnValueToken(params);
      this.axios.post(this.api.api_editDigitalWallet, this.util.encodeSearchParams(params)).then(res => {
          this.showloding = false;
          if (res.data.code == 0) {
            mui.toast("Modification succeeded");
            this.isEdit=false;
            this.list = [];
            this.getWallet();
          } else {
            mui.toast(res.data.message);
          }
        })
        .catch(() => {
          this.showloding = false;
          mui.toast("Modification failed");
        });
    },
    delWallet(id) {
      let _this = this;
      mui.confirm("Are you sure you want to delete this wallet?", "Hint", ["No", "Yes"], function(e) {
        if (e.index == 1) {
          _this.deleteOne(id);
        } else {
          mui.confirm();
        }
      });
    },
    deleteOne(id){
      let params = {id:id};
      this.util.setDnValueToken(params);
      this.axios.post(this.api.api_deleteDigitalWallet, this.util.encodeSearchParams(params)).then(res => {
          this.showloding = false;
          if (res.data.code == 0) {
            this.list = [];
            this.getWallet();
          } else {
            mui.toast(res.data.message);
          }
        })
    },
    showMore() {
      if (this.hasMore) {
        this.pageNo += 1;
        this.getWallet();
      }
    },
    getWallet() {
      this.showloding = true;
      let params = {}
      this.util.setDnValueUser(params);
      this.axios.get(this.api.api_getDigitalWallet, { params: params }).then(res => {
          if (this.pageNo == 1) this.nodata = true;
          this.showloding = false;
          if (res.data.code == 0) {
            let list = res.data.data;
            if (list.length > 0) {
              this.nodata = false;
              this.list = this.list.concat(list);
            } else {
              this.hasMore = false;
            }
          } else {
            this.util.checkToken(res.data.message);
          }
        });
    },
  },
  activated() {
    if (this.util.isLogin()) {
      this.userInfo = this.util.user;
      this.list = [];
      this.getWallet();
    }
  }
};
</script>
<style lang="scss" scoped>
.home-content {
  font-size: 0.34rem;
  background: rgb(235, 235, 235);
  color: rgb(103, 103, 103);
  width: 100%;
  height: 100%;
  
  .van_picker{
    background-color: rgb(164, 194, 219);
    width:100%;
    border-radius: 10px/10px;
  }
  .mine-header {
    color: black;
    font-weight: bold;
    height: 1rem;
    display: grid;
    grid-template-columns: 30% 1fr 30%;
    align-items: center;
    text-align: center;

    .back {
      cursor: pointer;

      img {
        display: block;
        margin-left: 5%;
        width: 0.5rem;
        transform: rotate(180deg);
      }
    }

    .add-wallet {
      margin-top: 0;
      display: flex;
      justify-content: right;
      padding-right: 0.2rem;

      img {
        display: block;
        width: 0.7rem;
      }
    }
  }

  .third-pard {
    height: 100%;
    padding-bottom: 160px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;

    .nodata {
      margin-top: 50px;
      height: 50px;
      display: grid;
      justify-content: center;
      font-size: 0.32rem;

      img {
        display: block;
        width: 35px;
        margin: auto;
      }
    }

    .show-more {
      height: 50px;
      display: flex;
      cursor: pointer;
      justify-content: center;
      align-items: center;
    }

    .edit-wallet {
      display: flex;
      justify-content: center;
      margin-top: 10px;

      .btn {
        background: #628808;
        color: white;
        font-size: 0.34rem;
        border-radius: 4px;
        width: 47%;
        height: 40px;
        margin: 0 0.1rem;
      }

      :nth-child(2) {
        background: #f6543e;
      }

      .btn:hover {
        background: #628808;
      }
    }

    .list {
      width: 97%;
      display: grid;
      grid-template-columns: 1fr 2%;
      align-items: center;
      margin: 10px auto;
      margin-top: 0;
      border-radius: 10px/10px;
      background-color: white;
      padding: 10px 10px;

      .des {
        display: grid;
        grid-template-columns: 86px 1fr 40px;
        padding: 1px 0;
        font-size: 0.34rem;
        :nth-child(1) {
          font-weight: bold;
          font-size: 0.34rem;
        }
        :nth-child(2){
          overflow-wrap: break-word;
          max-width: 5.8rem;
        }
        button{
          color:brown;
        }
      }
    }
  }
  .edit-pard {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    background: rgb(235, 235, 235);
    font-size: 0.34rem;

    .edit-head {
      height: 1rem;
      display: grid;
      grid-template-columns: 20% 1fr 20%;
      align-items: center;
      text-align: center;
      font-size: 0.34rem;
      color:black;
      font-weight: bold;

      :nth-child(1) {
        cursor: pointer;
        img {
          display: block;
          margin-left: 5%;
          width: 0.5rem;
          transform: rotate(180deg);
        }
      }
    }

    .edit-content {
      position: absolute;
      margin: auto;
      height: 300px;
      width: 96%;
      left: 50%;
      font-size: 0.34rem;
      transform: translateX(-50%);

      ul li {
        margin-bottom: 6px;
        font-size: 0.34rem;
        input{
          width: 100%;
          height: 40px;
          border-radius: 10px/10px;
          padding-left: 50px;
          border: solid 1px rgb(225, 225, 225);
          padding-left: 120px;
          font-size: 0.34rem;
        }

        textarea{
          width: 100%;
          height: 100px;
          border-radius: 10px/10px;
          padding-left: 80px;
          border: solid 1px rgb(225, 225, 225);
          padding-left: 120px;
          padding-top: 8px;
        }
        .icon-input {
          position: absolute;
          width: 120px;
          font-weight: bold;
          height: 40px;
          display: flex;
          align-items: center;
          padding-left: 4px;
        }

        button {
          width: 100%;
          border-radius: 4px;
          font-size: 0.34rem;
          height: 40px;
        }

        .btn-submit {
          background: #628808;
          color: white;
        }

        .btn-submit:hover {
          background: #628808;
        }
      }
    }
  }
}</style>  